/* eslint-disable no-restricted-globals */

'use strict';

/**
 * Creates Member Pricing Modal
 */
function getUARModalDiv() {
    if ($('#uarModal').length) {
        $('#uarModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal g-modal g-modal-uarexclusive" id="uarModal" role="dialog" data-backdrop="static">'
        + '<div class="modal-dialog g-modal-dialog ">'
        + '<!-- Modal content-->'
        + '<div class="modal-content g-modal-content">'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Displays guest popup when the unlock access CTA is clicked
 */
function displayGuestPopup() {
    $('body').on('uarexclusive:guestpopup', function (e, data) {
        if (data.uarExclusivePopup) {
            getUARModalDiv();
            $('body').find('.modal-backdrop.show').remove();
            $('#uarModal .g-modal-content').empty();
            $('#uarModal .g-modal-content').html(data.uarExclusivePopup);
            $('#uarModal').modal('show');
            $('#uarModal').next('.modal-backdrop.show').css('z-index', '999');
            var urlParams = new URLSearchParams(window.location.search);
            urlParams.set('uarProductID', data.pid);
            urlParams.set('uarQty', $('.js-quantity-select').val() || 1);
            urlParams.set('triggerATC', true);
            if ($('.sizeSplitUnisex').length) {
                urlParams.set('gender', $('.sizeSplitUnisex .js-firstSplit-select.selected').data('attr-value'));
            }
            window.uarProductID = data.pid;
            var hash = '';
            if (window.location.href.indexOf('#') !== -1) {
                hash = '#' + window.location.href.split('#')[1];
            }
            var urlWithProductParams = window.location.pathname + '?' + urlParams.toString() + hash;
            history.replaceState({}, '', urlWithProductParams);
        }
    });
}

/**
 * Displays ineligible popup when the add to cart CTA is clicked
 */
function displayIneligiblePopup() {
    $('body').on('uarexclusive:ineligiblepopup', function (e, data) {
        if (data.uarExclusivePopup) {
            getUARModalDiv();
            $('body').find('.modal-backdrop.show').remove();
            $('#uarModal .g-modal-content').empty();
            $('#uarModal .g-modal-content').html(data.uarExclusivePopup);
            $('#uarModal').modal('show');
            $('#uarModal').next('.modal-backdrop.show').css('z-index', '999');
        }
    });
}

/**
 * This function is used to trigger add to cart and allow guest customers to add the product to cart without member price
 */
function addToCartWithoutMemberPrice() {
    $('body').on('click', '.js-add-without-memberprice', function (e) {
        e.preventDefault();
        window.memberPriceATC = true;
        $('.l-pdp.product-detail .b-product_actions-inner .js-add-to-cart').trigger('click');
        $('#uarModal').modal('hide');
    });
}

/**
 * Handles window variable if login, registration or member pricing modals are closed
 */
function onPopupClose() {
    $('body').on('hidden.bs.modal', '#uarModal', function () {
        if ($('.l-pdp').length > 0 && !window.keepUARModal) {
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('uarProductID')) {
                urlParams.delete('uarProductID');
                urlParams.delete('uarQty');
                urlParams.delete('triggerATC');
                urlParams.delete('gender');
            }
            var hash = '';
            if (window.location.href.indexOf('#') !== -1) {
                hash = '#' + window.location.href.split('#')[1];
            }
            history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString() + hash);
        } else if (window.keepUARModal) {
            delete window.keepUARModal;
        }
    });
}

module.exports = {
    displayGuestPopup: displayGuestPopup,
    displayIneligiblePopup: displayIneligiblePopup,
    addToCartWithoutMemberPrice: addToCartWithoutMemberPrice,
    onPopupClose: onPopupClose
};
